import ForecastPage from "./forecast-page";

export default ForecastPage;
